import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const getAllUsersByOrganization: UseCase<UserRepository, 'getAllByOrganization'> = repository => {
  return async groupUid => {
    return await repository.getAllByOrganization(groupUid)
  }
}
